import type { SelaChatMessage, SelaDecisionBrief, SelaDecisionBriefContextSummary } from '../../services/selaApi';

function InlineList({ items, emptyLabel = 'Not specified' }: { items?: string[]; emptyLabel?: string }) {
  const cleanItems = (items || []).filter(Boolean);
  if (!cleanItems.length) {
    return <span className="text-sm italic text-[#858a9a]">{emptyLabel}</span>;
  }
  return <span className="text-sm font-medium leading-relaxed text-[#334155]">{cleanItems.join(', ')}</span>;
}

export function findLatestDecisionBrief(messages: SelaChatMessage[]): SelaDecisionBrief | null {
  const overviewAssistants = messages.filter(
    (message) => message.role === 'assistant' && message.kind === 'overview',
  );
  const flagged = overviewAssistants.find(
    (message) =>
      message.status === 'complete' &&
      message.decisionBrief &&
      (message.agentMetadata as { isLatestBrief?: boolean } | undefined)?.isLatestBrief,
  );
  if (flagged?.decisionBrief) {
    return flagged.decisionBrief;
  }
  const fallback = [...overviewAssistants]
    .reverse()
    .find((message) => message.status === 'complete' && message.decisionBrief);
  return fallback?.decisionBrief ?? null;
}

export function SelaProjectContextSection({ context }: { context: SelaDecisionBriefContextSummary }) {
  return (
    <section className="mb-8 overflow-hidden rounded-2xl border border-[#dbe4f0] bg-white p-5 shadow-sm">
      <h2 className="text-lg font-bold tracking-tight text-[#0f172a]">Project Context</h2>
      <div className="mt-4 grid gap-4 md:grid-cols-2">
        <div>
          <p className="text-[11px] font-bold uppercase tracking-wide text-[#647488]">Subject parcel</p>
          <p className="mt-1 text-sm font-semibold text-[#0f172a]">{context.subjectParcel || 'Subject parcel'}</p>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-wide text-[#647488]">Deal stage</p>
          <p className="mt-1 text-sm font-semibold text-[#0f172a]">{context.dealStage || 'Early Screening'}</p>
        </div>
        <div>
          <p className="mb-2 text-[11px] font-bold uppercase tracking-wide text-[#647488]">Development paths</p>
          <InlineList items={context.selectedDevelopmentPaths} emptyLabel="Recommend likely paths" />
        </div>
        <div>
          <p className="mb-2 text-[11px] font-bold uppercase tracking-wide text-[#647488]">Priorities</p>
          <InlineList items={context.priorities} emptyLabel="Balanced evaluation" />
        </div>
      </div>
    </section>
  );
}
